var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Complete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3722003,4.58509445 C13.6917202,4.90461433 13.6917189,5.4226584 13.372199,5.74217828 L8.29549422,10.8188825 C8.15497284,10.9594039 7.976053,11.0381259 7.79251015,11.0550473 C7.55130095,11.0844645 7.29950055,11.0066014 7.11435595,10.8214568 L4.57600354,8.28310436 C4.25648367,7.96358448 4.25648367,7.44554041 4.57600354,7.12602054 C4.89552342,6.80650066 5.41356749,6.80650128 5.73308737,7.12602054 L7.70363763,9.09657142 L12.2151165,4.58509445 C12.5346363,4.26557458 13.0526804,4.26557458 13.3722003,4.58509445 Z",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A186E",
    x: 3,
    y: 13,
    width: 12,
    height: 1.4,
    rx: 0.7
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Complete.595855302fffbba29b55e8958c45484f.svg";